import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { IconSanitizerService } from '../../services/icon-sanitizer.service';
import { ColorType } from '../../types/status-color.type';

@Component({
    selector: 'lib-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class StatusIndicatorComponent implements OnChanges {
    @Input()
    iconName!: string;

    @Input()
    text: string;

    @Input()
    colorType: ColorType;

    @Input()
    statusIndicatorId?: string;

    svg?: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.text = '';
        this.colorType = 'idle';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['iconName']) this.svg = this.iconSanitizer.getIcon(this.iconName);
    }
}
